import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import BlockFields from './BlockFields'

export const BlockCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <BlockFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default BlockCreate
